module.exports = __webpack_public_path__ + "images/file_icons_v2/7z-70a29f325528d595506377feec3f9c63.svg";